import { env } from "@/app/config/env";
import { compareVersions, minimumVersionSchema, type MinimumVersion } from "@shared/contracts";
import { apiRequest } from "./api-client";

/**
 * THE VERSION FLOOR, ASKED AT LAUNCH.
 *
 * This is the mechanism that lets the database and the service move while an app nobody
 * can recall keeps running. Without it the failure mode is a parse error on an unrelated
 * screen, weeks later, from a user who cannot say which build they are on.
 */
export { compareVersions };

export type VersionVerdict = "ok" | "update-recommended" | "update-required";

export async function checkVersion(): Promise<{ verdict: VersionVerdict; info?: MinimumVersion }> {
  const result = await apiRequest<unknown>("/v1/meta/minimum-version", { timeout: 6 });
  // Unreachable is not "too old": a launch on a train must not become a wall.
  if (!result.ok) return { verdict: "ok" };

  const parsed = minimumVersionSchema.safeParse(result.data);
  if (!parsed.success) return { verdict: "ok" };

  const info = parsed.data;
  if (compareVersions(env.version, info.minimum) < 0) return { verdict: "update-required", info };
  if (compareVersions(env.version, info.recommended) < 0) {
    return { verdict: "update-recommended", info };
  }
  return { verdict: "ok", info };
}

